import { Download } from "lucide-react";

import { Button } from "@/components/ui/button";
import { HoverTooltip } from "@/components/ui/tooltip";

type DownloadIconButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  tooltip?: string;
  ariaLabel?: string;
  className?: string;
  size?: "default" | "sm" | "lg" | "icon";
};

export default function DownloadIconButton({
  onClick,
  disabled,
  tooltip = "Download PDF",
  ariaLabel = "Download PDF",
  className,
  size = "sm",
}: DownloadIconButtonProps) {
  return (
    <HoverTooltip
      content={tooltip}
      className="bg-gray-200 text-black"
      arrowColor="bg-gray-200 fill-gray-200"
    >
      <Button
        variant="outline"
        size={size}
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}
        className={[
          "border-secondary text-secondary hover:bg-secondary/10 hover:text-secondary",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <Download className="h-4 w-4" />
      </Button>
    </HoverTooltip>
  );
}

